import * as React from 'react'
import styled from 'styled-components'
import { navigate } from '@reach/router'
const { Autocomplete, SearchInput, Text, Icon, toaster } = require('evergreen-ui')

import { colors } from '../../utils/colors'

interface IState {
  searchText: string
}

enum searchTypesEnum {
  subtype = 'SubType',
}

const ITEM_HEIGHT = 48

class SearchContainer extends React.Component<any, any> {
  public state = {
    searchText: '',
  }

  public render() {
    return (
      <Container>
        <Autocomplete
          onChange={this.search}
          items={Object.keys(searchTypesEnum)}
          itemSize={ITEM_HEIGHT}
          renderItem={this.renderItem}
          isFilterDisabled={true}
          children={(props: any) => {
            const { getInputProps, getRef, inputValue } = props
            return (
              <SearchInput
                placeholder="Search"
                innerRef={getRef}
                value={inputValue}
                {...getInputProps()}
                onChange={(e: any) => {
                  this.handleSearchText(e)
                  getInputProps().onChange(e)
                }}
              />
            )
          }}
        />
      </Container>
    )
  }

  private handleSearchText(e: any) {
    this.setState({ searchText: e.target.value.toUpperCase() })
  }

  private renderItem = (item: any) => {
    const { searchText } = this.state
    if (!searchText) {
      return null
    }
    return (
      <SearchItem
        key={item.key}
        isSelected={item.isHighlighted}
        onClick={() => this.search(item.key)}
      >
        <Text className={'search-text'}>{searchText}</Text>
        <div className="search-type">
          <Text color={'muted'} size={300} marginRight={4}>
            In {searchTypesEnum[item.key as keyof typeof searchTypesEnum]}
          </Text>
          <Icon icon={'key-enter'} color={'muted'} size={12} marginTop={2} />
        </div>
      </SearchItem>
    )
  }

  private search = (item: keyof typeof searchTypesEnum) => {
    const { bankCode } = this.props
    if (searchTypesEnum[item] === searchTypesEnum.subtype) {
      const bankSubtype = bankCode + '_' + this.state.searchText
      navigate(`/search/banksubtype/${bankSubtype}`)
    }
    this.resetSearchState()
  }

  private resetSearchState = () => this.setState({ searchText: '' })
}

const Container = styled.div`
  width: 300px;
`

const SearchItem: any = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  height: ${ITEM_HEIGHT}px;
  padding: 0 8px 0 8px;
  justify-content: space-between;
  cursor: pointer;
  background: ${({ isSelected }: any) => (isSelected ? colors.hoverBackground : 'none')};
  :hover {
    background: ${colors.hoverBackground};
  }
  .search-type {
    display: flex;
    align-items: center;
    padding: 2px 4px;
    border-radius: 5px;
    margin: 0 4px;
    background: rgba(0, 0, 0, 0.01);
    border: solid 1px lightgrey;
    flex-shrink: 0;
  }
  .search-text {
    font-weight: 500;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: 12px;
  }
`

export default SearchContainer
